import { BarChart } from '@mui/x-charts/BarChart'
import { Paper, CircularProgress, Box } from '@mui/material'
import { useGetTradeInChartQuery } from 'store/dashboard'
import ChartTitle from './ChartTitle'
import NoDataAvailable from './NoDataAvailable'
import { useTimeRange } from './TimeRangeContext'
import { barChartSlotProps, chartSx } from './chartDefaults'

interface Props {
  memberTiers?: string
}

const TradeInChart = ({ memberTiers }: Props) => {
  const { startDate, endDate } = useTimeRange()

  const { data, isLoading, isError, refetch, isFetching } = useGetTradeInChartQuery({
    startDate,
    endDate,
    memberTiers: memberTiers || undefined
  })

  return (
    <Paper
      sx={{
        p: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        boxShadow: 'none'
      }}
      elevation={0}
    >
      <ChartTitle tooltip='The number of Trade In by member tier'>Trade In</ChartTitle>

      {isLoading || isFetching ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
          <CircularProgress />
        </Box>
      ) : isError ? (
        <NoDataAvailable variant='error' onRefresh={refetch} />
      ) : !data ? (
        <NoDataAvailable onRefresh={refetch} />
      ) : (data.data ?? []).length === 0 ? (
        <NoDataAvailable onRefresh={refetch} />
      ) : (
        <Box sx={{ width: '100%', height: 300 }}>
          <BarChart
            xAxis={[
              {
                scaleType: 'band',
                data: data.data.map((d) => d.tier),
                label: 'Member Tier'
              }
            ]}
            yAxis={[{ tickMinStep: 1 }]}
            series={[
              {
                label: 'Hyundai',
                data: data.data.map((d) => d.hyundaiCount),
                color: '#002C5F'
              },
              {
                label: 'Non-Hyundai',
                data: data.data.map((d) => d.nonHyundaiCount),
                color: '#91979d'
              }
            ]}
            height={300}
            slotProps={barChartSlotProps}
            sx={chartSx}
          />
        </Box>
      )}
    </Paper>
  )
}

export default TradeInChart
